import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaXTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
  FaWhatsapp,
} from "react-icons/fa6";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="footer-section">
          <h3>Contact Details</h3>
          <p>Techstrike Club, CINEC Campus</p>
          <p>Millennium Drive, IT Park, Malabe, Sri Lanka.</p>
          <p>
            Phone:  <a href="tel:+94778602219">+94 77 860 2219, </a> <a href="tel:+94753471667">+94 75 347 1667, </a> <a href="tel:+94764517714">+94 76 451 7714 </a>
          </p>
          <p>
            Email: <a href="mailto:cinectechstrike@gmail.com">cinectechstrike@gmail.com</a>
          </p>
        </div>

        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
            <li><Link to="/events">Events</Link></li>
            <li><Link to="/Sub_Pillars">Pillars</Link></li>
            <li><Link to="/announcement">Announcement</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Follow Us</h3>
          <div className="footer-social-icons">
            <a href="https://www.facebook.com/TechStrikeCINEC/" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
            <a href="https://chat.whatsapp.com/J4BpgflCpk15ltcHqp4xIh" target="_blank" rel="noopener noreferrer"><FaWhatsapp /></a>
            <a href="https://instagram.com/techstrike2k21?igshid=xo2f6nqacm26" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
            <a href="#!" target="_blank" rel="noopener noreferrer"><FaXTwitter /></a>
            <a href="#!" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /></a>
            <a href="#!" target="_blank" rel="noopener noreferrer"><FaYoutube /></a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          All copyrights reserved by © 2025 Tech Strike.
        </p>
        <p>
          <a href="#!">Terms & Conditions</a> | <a href="#!">Privacy Policy</a> |{" "}
          <a href="#!">Sitemap</a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
